import { OutcomeOptimizationRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/outcome-optimization/$runId')({
  component: OutcomeOptimizationRoute,
});
